import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=6c920904&scoped=true"
import script from "./documents.vue?vue&type=script&lang=js"
export * from "./documents.vue?vue&type=script&lang=js"
import style0 from "./documents.vue?vue&type=style&index=0&id=6c920904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c920904",
  null
  
)

export default component.exports